import { createSlice } from "@reduxjs/toolkit";

interface ThemeState {
    mode: "light" | "dark";
}

const THEME_STORAGE_KEY = "Hubmicrooo-theme-mode";

const initialState: ThemeState = {
    mode: "dark",
};

export const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        toggleTheme: (state) => {
            state.mode = state.mode === "light" ? "dark" : "light";
        },
        setTheme: (state, action) => {
            state.mode = action.payload;
        },
    },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export { THEME_STORAGE_KEY };
export default themeSlice.reducer;
